<app-header></app-header>

<div class="container mt-5 mb-5">
  <div class="container image-container text-center">
    <img src="assets/mail.png" alt="" height="250" />
    <div class="row">
      <div class="d-flex justify-content-center">
        <div class="col-12 col-lg-6">
          <div class="text-center">
            <h1 style="color: #00943a; margin-bottom: 1rem;">
              <strong>Your email has been verified</strong>
            </h1>
            <button
              class="mt-3 mb-3"
              mat-raised-button
              color="primary"
              class="text-white"
              [style.width.%]="100"
              type="button"
              (click)="navigateLogin()"
            >
              Go to login
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
